import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=1a9a7130&scoped=true"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=js"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&id=1a9a7130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a7130",
  null
  
)

export default component.exports